import React from 'react'
import Form from 'types/Form'

function TextArea(props: Form.TextArea) {
  const {
    name,
    value,
    onChange,
    ...rest
  } = props

  return (
    <textarea
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...rest}
      id={`${name}_input`}
      key={`${name}_input`}
      name={name}
      className={`form-control ${rest.className ?? ''}`}
      value={value ?? ''}
      onChange={onChange}
    />
  )
}

export default TextArea
